const FAQ_ITEMS = [
  {
    id: 1,
    question: '8090影院真的完全免费吗？',
    answer: '是的，8090影院始终坚持免费电影大全的定位，所有影片均可免费在线观看。我们通过技术优化和资源整合来维持运营，不会向用户收取任何费用，也不会强制播放广告。',
  },
  {
    id: 2,
    question: '为什么我在8090影院看视频不卡顿？',
    answer: '我们采用全国分布式CDN加速网络和智能多线路切换技术，根据你的网络环境自动选择最优线路。即使家庭宽带只有20M，也能流畅观看1080P高清电影，真正实现不缓冲影院体验。',
  },
  {
    id: 3,
    question: '手机端观影体验怎么样？',
    answer: '8090影院针对移动端做了全面优化，支持手势控制亮度、音量和播放进度。无论在通勤路上还是睡前放松，小屏也能享受沉浸式高清电影在线观看体验。目前支持iOS和Android全系列设备。',
  },
  {
    id: 4,
    question: '影片画质支持哪些清晰度？',
    answer: '平台提供从720P到4K超高清的多种画质选择，系统会根据你的网速和设备屏幕自动推荐最佳画质。你也可以手动切换清晰度，大部分新片和热门影片都支持1080P及以上高清画质。',
  },
  {
    id: 5,
    question: '如何推荐我想看的电影？',
    answer: '欢迎通过联系投稿页面或发送邮件至 submit@8090cinema.com 推荐影片。我们的内容团队会评估每条推荐，优先上架呼声高的作品。你也可以在热门话题区参与讨论，让更多人看到你喜欢的电影。',
  },
  {
    id: 6,
    question: '8090影院的片源更新频率如何？',
    answer: '我们的片库每日持续更新，平均每天新增50部以上影片资源。新片上映后通常在1-2周内上线，经典老片的修复版本也会陆续入库。建议关注最新快讯模块获取实时更新信息。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            关于8090影院的常见问题，这里有你想要的答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 gap-4">
            {FAQ_ITEMS.map((item) => (
              <details
                key={item.id}
                className="bg-background-50 rounded-xl border border-background-200/30 group cursor-pointer overflow-hidden"
              >
                <summary className="flex items-center justify-between p-5 md:p-6 list-none select-none">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                    {item.question}
                  </h3>
                  <div className="w-7 h-7 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0 group-open:bg-primary-500/10 transition-colors">
                    <i className="ri-add-line text-foreground-500 group-open:hidden"></i>
                    <i className="ri-subtract-line text-primary-500 hidden group-open:block"></i>
                  </div>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-500 leading-relaxed border-t border-background-200/20 pt-4">
                    {item.answer}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}